import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {UserProfileApiService} from '../api/user-profile-api.service';
import {GetProfileImageAction, GetUserProfileAction, UploadProfileImageAction} from '../actions/user-profile.actions';
import {UserProfile} from '../models/user-profile.model';
import {UserPreferences} from '../models/user-preferences.model';
import {VerifyInformationAction} from '../actions/account.actions';
import {CompanyData} from '../models/company-data.model';
import {SendToast} from '../actions/toast.actions';
import {ToastType} from '../actions/core.actions';
import {AccountStateModel} from './account.state';
import {IncrementLimitApiService} from '../api/increment-limit.api.service';
import {UserFisicaData, UserJuridicaData} from '../models/user-data.model';
import {
  DownloadUserDocumentByIdAction,
  GetUserDocumentAction,
  IncrementLimitFisicaAction,
  IncrementLimitJuridicaAction,
  UpdateUserDocumentWithTypeIdAction
} from '../actions/increment-limit.action';
import {UserDocumentTypeListRequest} from '../models/user-document-type-list-request';
import {UserDocumentModel} from '../models/user-document.model';
import {MastersStateModel} from './masters.state';

export interface IncrementLimitStateModel {
  documents: UserDocumentModel[];
}

const initialState: IncrementLimitStateModel = {
  documents: null,
};

@State<IncrementLimitStateModel>({
  name: new StateToken<IncrementLimitStateModel>('incrementLimitState'),
  defaults: initialState
})
@Injectable()
export class IncrementLimitState {

  constructor(
    private store: Store,
    private incrementLimitApiService: IncrementLimitApiService,
  ) {
  }

  @Action(IncrementLimitFisicaAction)
  handleIncrementUserFisicaLimitAction(ctx: StateContext<IncrementLimitStateModel>, action: IncrementLimitFisicaAction) {
    const userDocumentListRequest: any = action.payload.userDocumentListRequest;

    return this.incrementLimitApiService.incrementUserFisicaLimit(userDocumentListRequest).pipe(
      tap(incrementUserFisicaLimitDataResponse => {
        return this.store.dispatch([new SendToast({
          title: 'Correcto',
          content: 'Verificación Iniciada',
          style: ToastType.Success,
          timeout: 8000,
          closeable: false,
          progress: false,
          timestamp: new Date().getTime()
        })]);
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  @Action(IncrementLimitJuridicaAction)
  handleIncrementUserJuridicaLimitAction(ctx: StateContext<IncrementLimitStateModel>, action: IncrementLimitJuridicaAction) {

    const userDocumentListRequest: any = action.payload.userDocumentListRequest;

    return this.incrementLimitApiService.incrementUserJuridicaLimit(userDocumentListRequest).pipe(
      tap(incrementUserFisicaLimitDataResponse => {
        return this.store.dispatch([new SendToast({
          title: 'Correcto',
          content: 'Verificación Iniciada',
          style: ToastType.Success,
          timeout: 8000,
          closeable: false,
          progress: false,
          timestamp: new Date().getTime()
        })]);
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  @Action(UpdateUserDocumentWithTypeIdAction)
  handleUpdateUserDocumentWithTypeIdActionAction(ctx: StateContext<IncrementLimitStateModel>, action: UpdateUserDocumentWithTypeIdAction) {

    let userDocumentTypeList: UserDocumentTypeListRequest = action.payload.userDocumentTypeList;

    return this.incrementLimitApiService.updateUserDocumentWithTypeId(userDocumentTypeList).pipe(
      tap(value => {
        console.log('Value', value);
        return this.store.dispatch([new SendToast({
          title: 'Correcto',
          content: 'Subida de documentos Iniciada',
          style: ToastType.Success,
          timeout: 8000,
          closeable: false,
          progress: false,
          timestamp: new Date().getTime()
        })]);
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  @Action(GetUserDocumentAction)
  handleGetUserDocumentAction(ctx: StateContext<IncrementLimitStateModel>, action: GetUserDocumentAction): Observable<any> {

    return this.incrementLimitApiService.getDocuments().pipe(
      tap(value => {
        console.log('Value', value);
        ctx.patchState({
          documents: value
        });
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }
  @Action(DownloadUserDocumentByIdAction)
  handleDownloadUserDocumentByIdAction(ctx: StateContext<IncrementLimitStateModel>, action: DownloadUserDocumentByIdAction): Observable<any> {
    const documentId = action.payload.documentId;
    return this.incrementLimitApiService.getUserDocument(documentId).pipe(
      tap(value => {
        window.open(value.linkTmp, '_self');
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }
  @Selector()
  static GetUserDocumentList(state: IncrementLimitStateModel) {
    return state?.documents;
  }
}
